module.exports = __webpack_public_path__ + "img/30.e04dd91.png";